import { Icon, IconButton, TextArea } from '@yembo/yemblocks-core';
import { useState } from 'react';
import { SelectedImage } from '../ImageSelector';

const MAX_LENGTH = 1600;

type Props = {
  isSending: boolean;
  selectedImages: SelectedImage[];
  onOpenImageSelectorModal: () => void;
  onSubmit: (message: string, clearMessage: () => void) => void;
};

export const ReplyBox = ({
  isSending,
  selectedImages,
  onOpenImageSelectorModal,
  onSubmit,
}: Props): React.JSX.Element => {
  const [message, setMessage] = useState('');
  const onMessageChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const message = e.currentTarget.value;
    setMessage(message.length > MAX_LENGTH ? message.substring(0, MAX_LENGTH) : message);
  };

  return (
    <div className='messages-input-wrap'>
      <TextArea
        rows={4}
        value={message}
        onChange={onMessageChange}
        placeholder='Type your message'
        autoFocus={true}
        onKeyDown={(e) => {
          if (!e.shiftKey && e.key === 'Enter') {
            e.preventDefault();

            if (message || selectedImages.length) {
              onSubmit(message, () => setMessage(''));
            }
          }
        }}
      />

      <div className={`messages-options-wrap ${isSending ? 'disabled' : ''}`}>
        <div
          className={`tiny-text character-count ${message ? '' : 'disabled'}`}
        >{`${message.length} / ${MAX_LENGTH}`}</div>
        <IconButton onClick={onOpenImageSelectorModal} kind='flat' icon={<Icon name='image' />} />
        <IconButton
          icon={<Icon name='paper-airplane' />}
          onClick={() => onSubmit(message, () => setMessage(''))}
          isDisabled={!selectedImages.length && !message}
          kind='flat'
        />
      </div>

      <div className='selected-images-container'>
        {selectedImages.map(({ key, importedUrl }) => (importedUrl ? <img key={key} src={importedUrl} /> : null))}
      </div>
    </div>
  );
};
